export const closeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width={32} height={32}
            viewBox="0 0 28 28"
            fill="var(--dark-brown-color)"
        >
            <path
                fillRule="evenodd"
                d="M20.364 7.636a.5.5 0 0 1 0 .707L14.707 14l5.657 5.657a.5.5 0 0 1-.707.707L14 14.707l-5.657 5.657a.5.5 0 0 1-.707-.707L13.293 14 7.636 8.343a.5.5 0 0 1 .707-.707L14 13.293l5.657-5.657a.5.5 0 0 1 .707 0Z"
                clipRule="evenodd"
            />
        </svg>
    );
};